// In production (same origin), API_URL is empty so fetch uses relative paths.
// In development, it points to the local Express server.
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const API_URL = isDev ? 'http://localhost:4000' : '';
